export const MediaImage = ({ media, className = "", imgClassName = "", sizes = "100vw", priority = false, badge = true, badgeTop = false, testId }) => (
  <div className={`relative overflow-hidden bg-slate-100 ${className}`} data-testid={testId}>
    <img
      src={media.src}
      srcSet={media.srcSet}
      sizes={media.srcSet ? sizes : undefined}
      alt={media.alt}
      width={media.width}
      height={media.height}
      loading={priority ? "eager" : "lazy"}
      fetchPriority={priority ? "high" : undefined}
      decoding={priority ? "sync" : "async"}
      className={`h-full w-full object-cover ${imgClassName}`}
    />
    {badge && media.sfeerbeeld && (
      <span className={`absolute rounded-md bg-white/85 px-2 py-0.5 text-[11px] font-medium text-slate-700 backdrop-blur-sm ${badgeTop ? "left-3 top-3" : "bottom-2.5 right-2.5"}`}
        data-testid={testId ? `${testId}-sfeerbeeld` : undefined}>
        {media.badge || "Sfeerbeeld"}
      </span>
    )}
  </div>
);
